import React from "react";
import { UseFormWatch, UseFormSetValue } from "react-hook-form";
import { FormSection } from "./FormSection";
import { FormSchemaType } from "../FormEditView";

interface ContactSectionProps {
  watch: UseFormWatch<FormSchemaType>;
  setValue: UseFormSetValue<FormSchemaType>;
}

export function ContactSection({ watch, setValue }: ContactSectionProps) {
  const fanIdentityCollection = watch("fanIdentityCollection");

  return (
    <FormSection id="section-contact" title="Contact Collection">
      <p className="text-sm text-muted-foreground leading-normal">
        Choose how to collect contact details (name, email, and phone) on form entry. <strong>Note:</strong> Bypassed if
        accessed via a direct fan link.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          {
            value: "hidden",
            title: "Anonymous",
            description: "Do not collect contact info. Users submit responses anonymously.",
          },
          {
            value: "optional",
            title: "Optional",
            description: "Ask for name, email, and phone, but allow users to skip.",
          },
          {
            value: "required",
            title: "Required",
            description: "Require name, email, and phone before filling out the form.",
          },
        ].map(card => {
          const isSelected = fanIdentityCollection === card.value;
          return (
            <button
              key={card.value}
              type="button"
              onClick={() => setValue("fanIdentityCollection", card.value as any, { shouldDirty: true })}
              className={`flex flex-col text-left p-5 rounded-xl border-2 transition-all duration-200 outline-none focus:ring-2 focus:ring-primary/20 ${
                isSelected
                  ? "border-primary bg-primary/5 shadow-md"
                  : "border-border hover:border-slate-300 hover:shadow-sm bg-card"
              }`}
            >
              <div className="flex items-center justify-between w-full mb-2">
                <span className={`font-sans font-bold text-sm ${isSelected ? "text-primary" : "text-slate-800"}`}>
                  {card.title}
                </span>
                <div
                  className={`size-4 rounded-full border flex items-center justify-center ${
                    isSelected ? "border-primary bg-primary" : "border-slate-300"
                  }`}
                >
                  {isSelected && <div className="size-1.5 rounded-full bg-white" />}
                </div>
              </div>
              <p className="font-sans text-sm text-muted-foreground leading-normal">{card.description}</p>
            </button>
          );
        })}
      </div>
    </FormSection>
  );
}
